import firebase from '@/scripts/firebase';

export default {
  async LOAD_DATA(context) {
    firebase.init();
    const data = firebase.loadData();
    const settings = firebase.loadSettings();
    const results = await Promise.all([data, settings])

    context.commit('SET_DATA', results[0]);
    context.commit('SET_SETTINGS', results[1]);
  },

  async SEND_FORM({ commit }, form) {
    const url = '/send-mail';

    await fetch(url, {
      method: 'POST',
      body: JSON.stringify(form),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => res.json()
      .then((data) => {
        if (data.status) {
          commit('FORM_STATUS', 'sent');
        }
    }));
  },
};
